var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShortWritewizLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3517_1280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0.177734H30.3938L26.3582 13.5396L22.2306 0.177734H15.7842L18.9843 10.4068L22.7875 23.9996H29.7908L38 0.177734Z",
    fill: "#682A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3583 13.5405L22.2306 0.180664H15.7832L18.9844 10.4097L22.7876 24.0025H29.7909L26.3583 13.5405Z",
    fill: "#682A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L8.1632 23.8219H15.1665L19.0168 10.229L22.263 0H15.8166L11.6418 13.3629L7.60628 0H0Z",
    fill: "#682A7A"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5113 16.6758L11.2559 16.6022L5.10156 14.8271L8.16355 23.8217H15.1669L16.7612 18.1961L11.5113 16.6758Z",
    fill: "url(#paint0_linear_3517_1280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5527 19.5859L22.788 23.9999H29.7913L30.4246 22.1626L21.5527 19.5859Z",
    fill: "url(#paint1_linear_3517_1280)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.8584 0.299947C33.6009 1.13131 33.0446 1.84059 32.2945 2.29378C31.5444 2.74697 30.6525 2.91268 29.7873 2.7596C29.6491 2.73578 29.624 2.73371 29.6187 2.7596C29.6135 2.78549 29.6418 2.79274 29.8208 2.85074C30.6707 3.11682 31.3877 3.69048 31.8286 4.45702C32.2537 5.18275 32.4043 6.03429 32.2536 6.85971C32.2264 7.01092 32.2253 7.03474 32.2473 7.04095C32.2693 7.04716 32.2787 7.02541 32.3206 6.89285C32.5727 6.06545 33.1211 5.35735 33.8629 4.90116C34.6048 4.44496 35.4894 4.27196 36.3509 4.41456C36.5278 4.44148 36.5603 4.44252 36.5603 4.42181C36.5603 4.40109 36.5435 4.39074 36.4106 4.34931C35.5714 4.09321 34.8557 3.54264 34.398 2.80113C33.9404 2.05962 33.7723 1.17824 33.9254 0.322731C33.9495 0.186026 33.9505 0.163242 33.9254 0.158064C33.9003 0.152885 33.8971 0.16842 33.8584 0.299947Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3517_1280",
    x1: 5.71597,
    y1: 19.7596,
    x2: 16.9435,
    y2: 18.6209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3517_1280",
    x1: 21.9638,
    y1: 22.1561,
    x2: 30.5059,
    y2: 21.2897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3517_1280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortWritewizLogo);
export default __webpack_public_path__ + "static/media/shortWritewizLogo.079db5e861cd275b48a7acb245961160.svg";
export { ForwardRef as ReactComponent };